/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-11-30 18:20:52
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-03-19 19:50:04
 */
const doctor = [
    // 找医生
    {
        path: '/freeclinic',
        name: 'freeclinic',
        component: () => import('../views/doctor/doctor-list.vue'),
    },
    {
        path: '/dutyList',
        name: 'dutyList',
        component: () => import('../views/doctor/duty-list.vue'),
    },
    {
        path: '/freeclinic/search',
        name: 'freeclinicSearch',
        component: () => import('../views/doctor/search-doctor.vue'),
    },
    {
        path: '/doctor/detail/:id',
        name: 'freeclinicDetail',
        component: () => import('../views/doctor/detail.vue'),
    },
    {
        path: '/doctorlist',
        name: 'doctorlist',
        component: () => import('../views/doctor/my-doctor-list.vue'),
        
    },
    {
        path: '/businessReg/:salerId',
        name: 'businessReg',
        component: () => import('../views/login/doctor-reg.vue'),
        meta:{
            keepAlive:true
        }
    },
    {
        path: '/doctorReg/:hospId',
        name: 'doctorReg',
        component:  () => import('../views/login/doctor-reg.vue'),
        meta:{
            keepAlive:true
        }
    },
]
export default doctor



// WEBPACK FOOTER //
// ./src/router/doctor.js